import { MechanicValidator } from './MechanicValidator.ts';
import { PieceTypes } from '@colonist/game-base-types';
import { getCardsForPiece } from '@colonist/game-card-types';
import { ActionState, PlayerColor, TileCornerBuildingType } from '@colonist/game-states';
import { ArrayUtils } from '@colonist/utils';
export class MechanicValidatorCity extends MechanicValidator {
    getCityPlayerState(player) {
        if (player == PlayerColor.None) {
            return {
                bankCityAmount: 0
            };
        }
        const cityPlayerState = this.cityState[player];
        if (cityPlayerState === undefined) throw new Error(`No MechanicCityPlayerState for player ${player}`);
        return cityPlayerState;
    }
    hasResourcesAndPiecesForCity(player, useResourcesAndSettlement, discount) {
        const playerController = this.playerValidators.get(player);
        if (playerController == undefined) return {
            canTakeAction: false,
            errorMessageIfCantTakeAction: {
                key: 'strings:game.errors.noPlayer'
            }
        };
        const cityPlayerState = this.getCityPlayerState(player);
        if (cityPlayerState.bankCityAmount <= 0) return {
            canTakeAction: false,
            errorMessageIfCantTakeAction: {
                key: 'strings:game.errors.notEnoughCityPieces'
            }
        };
        if (!useResourcesAndSettlement) return {
            canTakeAction: true
        };
        const placedSettlementAmount = this.mapValidator.tileState.getPlacedCornerBuildingCountForPlayer(TileCornerBuildingType.Settlement, player);
        if (placedSettlementAmount <= 0) return {
            canTakeAction: false,
            errorMessageIfCantTakeAction: {
                key: 'strings:game.errors.noSettlementToUpgrade'
            }
        };
        var _ref;
        discount = (_ref = discount !== null && discount !== void 0 ? discount : cityPlayerState.nextCityDiscount) !== null && _ref !== void 0 ? _ref : [];
        const resourcesForCity = getCardsForPiece(PieceTypes.City);
        ArrayUtils.removeElementsFromArray(resourcesForCity, discount);
        const hasResourcesForCity = playerController.hasResourceCardsInHand(resourcesForCity);
        if (!hasResourcesForCity) return {
            canTakeAction: false,
            errorMessageIfCantTakeAction: {
                key: 'strings:game.errors.notEnoughResources'
            }
        };
        return {
            canTakeAction: true
        };
    }
    canPlayerPlaceCity(player) {
        const isSomePlayerDiscarding = this.currentStateValidator.isSomePlayerInActionState(ActionState.SelectCardsToDiscard);
        if (isSomePlayerDiscarding) return {
            canTakeAction: false,
            errorMessageIfCantTakeAction: {
                key: 'strings:game.errors.playersDiscarding'
            }
        };
        const useResourcesAndSettlement = true;
        const doesPlayerHaveResourcesAndPiecesForCity = this.hasResourcesAndPiecesForCity(player, useResourcesAndSettlement);
        const { where } = this.whereCanPlayerPlaceCities(player);
        doesPlayerHaveResourcesAndPiecesForCity.validHoverLocations = where;
        if (!doesPlayerHaveResourcesAndPiecesForCity.canTakeAction) {
            return doesPlayerHaveResourcesAndPiecesForCity;
        }
        if (where.length <= 0) {
            return {
                canTakeAction: false,
                errorMessageIfCantTakeAction: {
                    key: 'strings:game.errors.noWhereToPlaceCity'
                },
                validHoverLocations: where
            };
        }
        return {
            canTakeAction: true,
            validHoverLocations: where
        };
    }
    whereCanPlayerPlaceCities(player) {
        const placesToBuildCityArray = [];
        for (const [index, corner] of this.mapValidator.tileState.tileCorners.entries()){
            if (corner.owner != player) continue;
            // Mar 20, 2021. If a player has a destroyed city they NEED to upgrade that city next
            if (corner.buildingType == TileCornerBuildingType.DestroyedCity) return this.whereCanPlayerUpgradeDestroyedCity(player);
            if (corner.buildingType != TileCornerBuildingType.Settlement) continue;
            placesToBuildCityArray.push(index);
        }
        return {
            where: placesToBuildCityArray,
            cornerBuildingTypeBeingUpgraded: TileCornerBuildingType.Settlement
        };
    }
    whereCanPlayerUpgradeDestroyedCity(player) {
        const whereCanPlayerUpgradeDestroyedCity = [];
        for (const [index, corner] of this.mapValidator.tileState.tileCorners.entries()){
            if (corner.owner != player) continue;
            if (corner.buildingType != TileCornerBuildingType.DestroyedCity) continue;
            whereCanPlayerUpgradeDestroyedCity.push(index);
        }
        return {
            where: whereCanPlayerUpgradeDestroyedCity,
            cornerBuildingTypeBeingUpgraded: TileCornerBuildingType.DestroyedCity
        };
    }
    constructor(playerValidators, mapValidator, currentStateValidator, cityState){
        super(playerValidators, mapValidator);
        this.currentStateValidator = currentStateValidator;
        this.cityState = cityState;
    }
}
